// Merged Directory workspace — combines the former Directory, Locations and
// Data Ops sidebar items into one tabbed hub.
import React from 'react';
import HubScreen from './HubScreen';
import DirectoryConsole from './DirectoryConsole';
import LocationEditor from './LocationEditor';
import VerifyQueue from './VerifyQueue';
import LocationProfile from './LocationProfile';
import DataOps from './DataOps';
import PlaceSuggestions from './PlaceSuggestions';

const TABS = [
  { id: 'directory',      label: 'Directory',       Component: DirectoryConsole },
  { id: 'locationeditor', label: 'Location Editor', Component: LocationEditor },
  { id: 'verifyqueue',    label: 'Verify Queue',    Component: VerifyQueue, badge: '4', bc: '#dc3545' },
  { id: 'placesuggestions', label: 'Suggestions',    Component: PlaceSuggestions },
  { id: 'locationsearch', label: 'Location Search', Component: LocationProfile },
  { id: 'dataops',        label: 'Data Ops',        Component: DataOps },
];

export default function DirectoryWorkspace(props) {
  return <HubScreen tabs={TABS} passProps={props} title="Directory" />;
}
